export const ErrorText = {
  NO_USER: 'Нет данных о пользователе',
  NO_USER_ORG: 'Нет данных об организации',
};

export const NO_DATA_TEXT = 'Не найдено';

export const ApplicantRightholderText = {
  LABEL:
    'Требуется указать сведения о заявителе, являющимся правообладателем объекта недвижимости или лицом, в пользу которого зарегистрированы ограничения или обременения в отношении объекта недвижимости',
  TITLE:
    'Сведения о заявителе, являющимся правообладателем объекта недвижимости или лицом, в пользу которого зарегистрированы ограничения или обременения в отношении объекта недвижимости',
};

export const SubjectFillTypeText = {
  MACHINE: 'Представитель заявителя по доверенности в машиночитаемом виде',
};
